<template>
  <div>
    <vs-row class="mb-4">
      <vs-col>
        <h5>
          <i class="dot"></i>{{ $t('종사자 안전보건 의견수렴 설문문항') }}</h5>
      </vs-col>
    </vs-row>

    <!-- 1. -->
    <div class="px-2 pb-3" style="font-size:16px; font-weight: 500;">{{ $t('1. 일하시는 업무분야는 어디입니까?') }}</div>
    <vs-row>
      <vs-col class="grid m-2" vs-align="center">
        <div v-if="isPrint" class="w-full px-4" style="align-items: center; display: contents;" >
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('1. 기획, 감사, 홍보, 행정지원') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1. 기획, 감사, 홍보, 행정지원') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('2. 대민 서비스') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('2. 대민 서비스') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('3. 안전, 보건') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('3. 안전, 보건') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('4. 문화, 관광') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('4. 문화, 관광') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('5. 일자리, 복지') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('5. 일자리, 복지') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('6. 교통,건설') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('6. 교통,건설') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('7. 인·허가') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('7. 인·허가') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('8. 환경, 녹지') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('8. 환경, 녹지') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('9. 농·수산') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('9. 농·수산') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('10. 산업단지관리사업소') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('10. 산업단지관리사업소') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('11. 의회') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('11. 의회') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input1 && form.input1.indexOf('12. 동 행정복지센터') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('12. 동 행정복지센터') }}</span>
        </div>
        <div v-else class="w-full px-4" style="align-items: center; display: contents;" >
          <vs-radio class="m-2" v-model="form.input1" vs-value="1. 기획, 감사, 홍보, 행정지원" color="secondary" :disabled="readonly">{{ $t('1. 기획, 감사, 홍보, 행정지원') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="2. 대민 서비스" color="secondary" :disabled="readonly">{{ $t('2. 대민 서비스') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="3. 안전, 보건" color="secondary" :disabled="readonly">{{ $t('3. 안전, 보건') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="4. 문화, 관광" color="secondary" :disabled="readonly">{{ $t('4. 문화, 관광') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="5. 일자리, 복지" color="secondary" :disabled="readonly">{{ $t('5. 일자리, 복지') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="6. 교통,건설" color="secondary" :disabled="readonly">{{ $t('6. 교통,건설') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="7. 인·허가" color="secondary" :disabled="readonly">{{ $t('7. 인·허가') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="8. 환경, 녹지" color="secondary" :disabled="readonly">{{ $t('8. 환경, 녹지') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="9. 농·수산" color="secondary" :disabled="readonly">{{ $t('9. 농·수산') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="10. 산업단지관리사업소" color="secondary" :disabled="readonly">{{ $t('10. 산업단지관리사업소') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="11. 의회" color="secondary" :disabled="readonly">{{ $t('11. 의회') }}</vs-radio>
          <vs-radio class="m-2" v-model="form.input1" vs-value="12. 동 행정복지센터" color="secondary" :disabled="readonly">{{ $t('12. 동 행정복지센터') }}</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <!-- 2. -->
    <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('2. 일하시는 중 사고 경험*이 있습니까?') }}</div>
    <div class="px-2 pt-1 pb-5" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('*업무와 관련하여 입은 부상. 다치지는 않았으나 부상으로 이어질 가능성 있었던 경우도 포함합니다.(예, 작업 중 넘어졌으나 다치지 않은 경우에도 포함하여 작성)') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('예') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('아니오') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('아니오') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="ml-2 mr-5" v-model="form.input2" vs-value="예" color="secondary" :disabled="readonly">{{ $t('1. 예') }}</vs-radio>
          <vs-radio class="mr-5" v-model="form.input2" vs-value="아니오" color="secondary" :disabled="readonly" @change="handleInitData('input2_1', '해당사항 없음')">{{ $t('2. 아니오') }}</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <!-- 2-1. -->
    <div v-if="form.input2 === '예'">
      <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('2-1. 사고는 어떤 유형입니까?') }}</div>
      <div class="px-2 pt-1 pb-2" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('[문2의 ‘1. 예’ 응답자만]') }}</div>
      <vs-row>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="w-full px-4" style="align-items: center;" >
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('떨어짐(높은 곳, 개구부(지붕, 바닥, 벽 등에 뚫려있는 곳)등에서 떨어져서 다침)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1. 떨어짐(높은 곳, 개구부(지붕, 바닥, 벽 등에 뚫려있는 곳)등에서 떨어져서 다침)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('넘어짐(미끄러지거나 걸려서 넘어지면서 다침)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('2. 넘어짐(미끄러지거나 걸려서 넘어지면서 다침)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('부딪힘(차량, 설비, 기계·기구, 구조물 등 물체와 부딪히거나 맞음)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('3. 부딪힘(차량, 설비, 기계·기구, 구조물 등 물체와 부딪히거나 맞음)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('끼임(물체와 물체 사이에 신체의 일부가 끼임으로 인해 다침)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('4. 끼임(물체와 물체 사이에 신체의 일부가 끼임으로 인해 다침)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('깔림, 뒤집힘(물체가 쓰러지거나 뒤집힐 때 갈리면서 다침)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('5. 깔림, 뒤집힘(물체가 쓰러지거나 뒤집힐 때 갈리면서 다침)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('무너짐(쌓여진 물체나 건축물이 무너지면서 다침)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('6. 무너짐(쌓여진 물체나 건축물이 무너지면서 다침)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('질식(각종 유해가스)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('7. 질식(각종 유해가스)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('감전(인체가 전선 등에 접촉하여 전류가 흘러 상처를 입거나 충경을 느낌)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('8. 감전(인체가 전선 등에 접촉하여 전류가 흘러 상처를 입거나 충경을 느낌)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('화재·폭발(주변 가연성 및 인화성 물질의 화재 및 폭발로 인해 다침)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('9. 화재·폭발(주변 가연성 및 인화성 물질의 화재 및 폭발로 인해 다침)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input2_1 && form.input2_1.indexOf('기타 유형') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>10. 기타 유형 {{form.input2_1_0}}</span>
          </div>
          <div v-else class="w-full px-2" style="align-items: center;" >
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="떨어짐(높은 곳, 개구부(지붕, 바닥, 벽 등에 뚫려있는 곳)등에서 떨어져서 다침)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('1. 떨어짐(높은 곳, 개구부(지붕, 바닥, 벽 등에 뚫려있는 곳)등에서 떨어져서 다침)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="넘어짐(미끄러지거나 걸려서 넘어지면서 다침)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('2. 넘어짐(미끄러지거나 걸려서 넘어지면서 다침)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="부딪힘(차량, 설비, 기계·기구, 구조물 등 물체와 부딪히거나 맞음)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('3. 부딪힘(차량, 설비, 기계·기구, 구조물 등 물체와 부딪히거나 맞음)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="끼임(물체와 물체 사이에 신체의 일부가 끼임으로 인해 다침)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('4. 끼임(물체와 물체 사이에 신체의 일부가 끼임으로 인해 다침)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="깔림, 뒤집힘(물체가 쓰러지거나 뒤집힐 때 갈리면서 다침)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('5. 깔림, 뒤집힘(물체가 쓰러지거나 뒤집힐 때 갈리면서 다침)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="무너짐(쌓여진 물체나 건축물이 무너지면서 다침)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('6. 무너짐(쌓여진 물체나 건축물이 무너지면서 다침)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="질식(각종 유해가스)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('7. 질식(각종 유해가스)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="감전(인체가 전선 등에 접촉하여 전류가 흘러 상처를 입거나 충경을 느낌)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('8. 감전(인체가 전선 등에 접촉하여 전류가 흘러 상처를 입거나 충경을 느낌)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="화재·폭발(주변 가연성 및 인화성 물질의 화재 및 폭발로 인해 다침)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('9. 화재·폭발(주변 가연성 및 인화성 물질의 화재 및 폭발로 인해 다침)') }}</vs-checkbox>
            <div class="flex">
              <vs-checkbox class="m-2 etc-input" v-model="form.input2_1" vs-value="기타 유형" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input2_1', '해당사항 없음')">{{ $t('10. 기타 유형') }}</vs-checkbox>
              <ml-input v-if="form.input3_1 && form.input2_1.includes('기타 유형')" class="w-1/2" v-model="form.input2_1_0"/>
            </div>

<!--            <vs-checkbox class="m-2" v-model="form.input2_1" vs-value="해당사항 없음" color="secondary" :disabled="readonly" @change="handleInitData('input2_1', '해당사항 없음')">{{ $t('해당사항 없음') }}</vs-checkbox>-->
          </div>
        </vs-col>
      </vs-row>
    </div>

    <!-- 3. -->
    <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('3. 업무와 관련하여 질병을 앓은 경험*이 있습니까?') }}</div>
    <div class="px-2 pt-1 pb-5" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('*업무상 사유로 발생한 질병. 화학물질, 생물학적 요인에 기인하거나 작업조건·방식 등에 의해 발병하여 의사의 진단을 받은 경우를 말합니다.') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input3 && form.input3.indexOf('예') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
          <span class="print-radio"><i><feather-icon v-if="form.input3 && form.input3.indexOf('아니오') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('아니오') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="ml-2 mr-5" v-model="form.input3" vs-value="예" color="secondary" :disabled="readonly">{{ $t('1. 예') }}</vs-radio>
          <vs-radio class="mr-5" v-model="form.input3" vs-value="아니오" color="secondary" :disabled="readonly" @change="handleInitData('input3_1', '해당사항 없음')">{{ $t('2. 아니오') }}</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <!-- 3-1. -->
    <div v-if="form.input3 === '예'">
      <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('3-1. 질병은 어떤 유형입니까?') }}</div>
      <div class="px-2 pt-1 pb-2" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('[문3의 ‘1. 예’ 응답자만]') }}</div>
      <vs-row>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="w-full px-4" style="align-items: center;" >
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_1 && form.input3_1.indexOf('근골격계질환(신체에 부담되는 힘·동작, 부적절한 작업자세 등으로 근육, 인대 등 손상)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('1. 근골격계질환(신체에 부담되는 힘·동작, 부적절한 작업자세 등으로 근육, 인대 등 손상)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_1 && form.input3_1.indexOf('뇌·심혈관계 질환(뇌출형, 심근경색 등 혈관에 이상이 생겨 발생하는 질환)') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('2. 뇌·심혈관계 질환(뇌출형, 심근경색 등 혈관에 이상이 생겨 발생하는 질환)') }}</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_1 && form.input3_1.indexOf('기타 질병') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>3. 기타 질병 {{form.input3_1_0}}</span>
          </div>
          <div v-else class="w-full px-2" style="align-items: center;" >
            <vs-checkbox class="m-2" v-model="form.input3_1" vs-value="근골격계질환(신체에 부담되는 힘·동작, 부적절한 작업자세 등으로 근육, 인대 등 손상)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input3_1', '해당사항 없음')">{{ $t('1. 근골격계질환(신체에 부담되는 힘·동작, 부적절한 작업자세 등으로 근육, 인대 등 손상)') }}</vs-checkbox>
            <vs-checkbox class="m-2" v-model="form.input3_1" vs-value="뇌·심혈관계 질환(뇌출형, 심근경색 등 혈관에 이상이 생겨 발생하는 질환)" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input3_1', '해당사항 없음')">{{ $t('2. 뇌·심혈관계 질환(뇌출형, 심근경색 등 혈관에 이상이 생겨 발생하는 질환)') }}</vs-checkbox>
            <div class="flex">
              <vs-checkbox class="m-2 etc-input" v-model="form.input3_1" vs-value="기타 질병" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input3_1', '해당사항 없음')">{{ $t('3. 기타 질병') }}</vs-checkbox>
              <ml-input v-if="form.input3_1 && form.input3_1.includes('기타 질병')" class="w-1/2" v-model="form.input3_1_0"/>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <!-- 4. -->
    <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('4. 일하시는 곳에서 사고가 발생할 수 있는 위험요인*이 있다면 모두 작성하여 주세요.') }}</div>
    <div class="px-2 pt-1" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('*해당 업무에서 발생할 가능성이 있는 사고 중심') }}</div>
    <div class="px-2 pb-2" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('*위험요인을 정확히 알 수 있도록 장소, 해당위험요인 등을 같이 작성해 주세요.') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-4" style="align-items: center;" >
          <span class="print-checkbox"><i><feather-icon v-if="form.input4 && form.input4.indexOf('떨어짐') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1. 떨어짐 {{form.input4_1}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input4 && form.input4.indexOf('넘어짐') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>2. 넘어짐 {{form.input4_2}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input4 && form.input4.indexOf('베 임') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>3. 베 임 {{form.input4_3}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input4 && form.input4.indexOf('끼 임') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>4. 끼 임 {{form.input4_4}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input4 && form.input4.indexOf('깔 림') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>5. 깔 림 {{form.input4_5}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input4 && form.input4.indexOf('기 타') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>6. 기 타 {{form.input4_6}}</span>
        </div>
        <div v-else class="w-full px-2" style="align-items: center;" >
          <div class="flex">
            <vs-checkbox class="m-2 etc-input" v-model="form.input4" vs-value="떨어짐" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input4', '해당사항 없음')">{{ $t('1. 떨어짐') }}</vs-checkbox>
            <ml-input v-if="form.input4 && form.input4.includes('떨어짐')" class="w-1/2" v-model="form.input4_1"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input4" vs-value="넘어짐" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input4', '해당사항 없음')">{{ $t('2. 넘어짐') }}</vs-checkbox>
            <ml-input v-if="form.input4 && form.input4.includes('넘어짐')" class="w-1/2" v-model="form.input4_2"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input4" vs-value="베 임" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input4', '해당사항 없음')">{{ $t('3. 베 임') }}</vs-checkbox>
            <ml-input v-if="form.input4 && form.input4.includes('베 임')" class="w-1/2" v-model="form.input4_3"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input4" vs-value="끼 임" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input4', '해당사항 없음')">{{ $t('4. 끼 임') }}</vs-checkbox>
            <ml-input v-if="form.input4 && form.input4.includes('끼 임')" class="w-1/2" v-model="form.input4_4"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input4" vs-value="깔 림" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input4', '해당사항 없음')">{{ $t('5. 깔 림') }}</vs-checkbox>
            <ml-input v-if="form.input4 && form.input4.includes('깔 림')" class="w-1/2" v-model="form.input4_5"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input4" vs-value="기 타" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input4', '해당사항 없음')">{{ $t('6. 기 타') }}</vs-checkbox>
            <ml-input v-if="form.input4 && form.input4.includes('기 타')" class="w-1/2" v-model="form.input4_6"/>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <!-- 5. -->
    <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('5. 일하시면서 건강에 영향(근골격계질환, 뇌·심형관질환, 소음성 난청 등 업무상 이유로 걸린 질병)을 미칠 수 있는 요인*이 있다면 모두 선택하여 주세요[복수선택]') }}</div>
    <div class="px-2 pt-1" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('*해당 업무에서 발생할 가능성이 있는 건강상 영향 중심') }}</div>
    <div class="px-2 pb-2" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('*건강상 유해요인을 정확히 알 수 있도록 장소, 해당요인, 작업내용 등을 같이 작성해주세요.') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-4" style="align-items: center;" >
          <span class="print-checkbox"><i><feather-icon v-if="form.input5 && form.input5.indexOf('과중한 업무') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1. 과중한 업무 {{form.input5_1}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input5 && form.input5.indexOf('관계갈등') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>2. 관계갈등 {{form.input5_2}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input5 && form.input5.indexOf('직장문화') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>3. 직장문화 {{form.input5_3}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input5 && form.input5.indexOf('반복작업') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>4. 반복작업 {{form.input5_4}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input5 && form.input5.indexOf('중량물취급작업') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>5. 중량물취급작업 {{form.input5_5}}</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input5 && form.input5.indexOf('기 타') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>6. 기 타 {{form.input5_6}}</span>
        </div>
        <div v-else class="w-full px-2" style="align-items: center;" >
          <div class="flex">
            <vs-checkbox class="m-2 etc-input" v-model="form.input5" vs-value="과중한 업무" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input5', '해당사항 없음')">{{ $t('1. 과중한 업무') }}</vs-checkbox>
            <ml-input v-if="form.input5 && form.input5.includes('과중한 업무')" class="w-1/2" v-model="form.input5_1"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input5" vs-value="관계갈등" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input5', '해당사항 없음')">{{ $t('2. 관계갈등') }}</vs-checkbox>
            <ml-input v-if="form.input5 && form.input5.includes('관계갈등')" class="w-1/2" v-model="form.input5_2"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input5" vs-value="직장문화" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input5', '해당사항 없음')">{{ $t('3. 직장문화') }}</vs-checkbox>
            <ml-input v-if="form.input5 && form.input5.includes('직장문화')" class="w-1/2" v-model="form.input5_3"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input5" vs-value="반복작업" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input5', '해당사항 없음')">{{ $t('4. 반복작업') }}</vs-checkbox>
            <ml-input v-if="form.input5 && form.input5.includes('반복작업')" class="w-1/2" v-model="form.input5_4"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input5" vs-value="중량물취급작업" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input5', '해당사항 없음')">{{ $t('5. 중량물취급작업') }}</vs-checkbox>
            <ml-input v-if="form.input5 && form.input5.includes('중량물취급작업')" class="w-1/2" v-model="form.input5_5"/>
          </div>
          <div class="flex py-1">
            <vs-checkbox class="m-2 etc-input" v-model="form.input5" vs-value="기 타" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input5', '해당사항 없음')">{{ $t('6. 기 타') }}</vs-checkbox>
            <ml-input v-if="form.input5 && form.input5.includes('기 타')" class="w-1/2" v-model="form.input5_6"/>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <!-- 6. -->
    <div class="px-2 pt-5" style="font-size:16px; font-weight: 500;">{{ $t('6. 기타 업무중 안전·보건을 위한 의견이 있으시면 작성하여 주시기 바랍니다.') }}</div>
    <ml-textarea class="m-2" v-model="form.input6"/>

    <!-- 7. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">{{ $t('7. 귀하의 직급은 어떻게 되십니까?') }}</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input7 && form.input7.indexOf('6급 이상') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('6급 이상') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input7 && form.input7.indexOf('7급 이하') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('7급 이하') }}</span>
          <span class="print-radio"><i><feather-icon v-if="form.input7 && form.input7.indexOf('기 타') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{ $t('기 타') }}</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="ml-2 mr-5" v-model="form.input7" vs-value="예" color="secondary" :disabled="readonly">{{ $t('6급 이상') }}</vs-radio>
          <vs-radio class="mr-5" v-model="form.input7" vs-value="예" color="secondary" :disabled="readonly">{{ $t('7급 이하') }}</vs-radio>
          <vs-radio class="mr-5" v-model="form.input7" vs-value="예" color="secondary" :disabled="readonly">{{ $t('기 타') }}</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <div class="px-2 pt-10" style="font-size:14px; font-weight: 400; color: #696D71">{{ $t('※ 설문에 응해주셔서 감사합니다.') }}</div>

  </div>
</template>

<script>
export default {
  name: 'SurveyTable',
  props: {
    isPrint: Boolean,
    value: Object,
    readonly: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler() {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.$emit("input", this.form);
      },
    },
  },
  computed: {
    checkHeads () {
      return Object.keys(this.form.input6_option2)
    },
    checkTableHeads () {
      const keys = Object.keys(this.form.input6_option2)
      const heads = []

      for (const key of keys) {
        if (this.form.input6_option1 && this.form.input6_option1.indexOf(key) >= 0) {
          heads.push(key)
        }
      }
      return heads
    },
  },
  data () {
    return {
      form: {
        input1: ['해당사항 없음'],
        input2: {},
        input2_1: ['해당사항 없음'],
        input2_1_0: '',
        input3: {},
        input3_1: ['해당사항 없음'],
        input3_1_0: '',
        input4: ['해당사항 없음'],
        input4_1: '',
        input4_2: '',
        input4_3: '',
        input4_4: '',
        input4_5: '',
        input4_6: '',
        input5: ['해당사항 없음'],
        input5_1: '',
        input5_2: '',
        input5_3: '',
        input5_4: '',
        input5_5: '',
        input5_6: '',
        input6: '',
        input7: {},

      }
    }
  },
  methods: {

    handleInitData (key, str) {
      if (typeof this.form[key] === 'object') {
        if (this.form[key].length > 0) {
          this.form[key] = [str]
        }
      } else if (typeof this.form[key] === 'string') {
        if (this.form[key]) {
          this.form[key] = str
        }
      }
    },

    handleRemoveDefault (key, str) {
      if (typeof this.form[key] === 'object') {
        const index = this.form[key].indexOf(str)
        if (index === 0 && this.form[key].length == 2) {
          this.form[key] = this.form[key].removeIndex(index)
        }
      } else if (typeof this.form[key] === 'string') {
        //this.form[key] = str
      }
    },


    handleInitDataWithCheckTable (key1, key2, str) {
      if (this.form.input6_option2[key1][key2] && this.form.input6_option2[key1][key2].length > 0) {
        this.form.input6_option2[key1][key2] = [str]
      }
    },

    handleRemoveDefaultWithCheckTable (key1, key2, str) {
      const index = this.form.input6_option2[key1][key2].indexOf(str)
      if (index === 0 && this.form.input6_option2[key1][key2].length == 2) {
        this.form.input6_option2[key1][key2] = this.form.input6_option2[key1][key2].removeIndex(index)
        this.form.input6_option2[key1][6] = ''
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.check-table {
  border-top: 1px solid #CDCDCD;
  border-left: 1px solid #CDCDCD;
  & > .vs-row {
    display: grid !important;
    grid-template-columns: 165px 1fr;

    .vs-col {
      border-right: 1px solid #CDCDCD;
      border-bottom: 1px solid #CDCDCD;
    }
    .vs-col:first-child {
      width: 165px;
    }
    .vs-col:last-child {
      display: flex;

      & > div:first-child {

      }
      & > div {
        width: 100%;
        display: flex;
        justify-content: center;

        & > div {
          width: 100%;
          max-width: 165px;
          display: grid;
          grid-template-columns: 1fr;
          justify-content: center;
          align-items: center;
          gap: 0.875rem;

          text-align: center;
          & > .vs-radio { width: 100%;}
          .checkbox_x.vs-checkbox { min-width:20px; min-height: 20px;}
        }
      }
    }
  }

  .table-border{
    border-right: 1px solid #CDCDCD;
    &:last-child{
      border-right: 0;
    }
  }

  /* 배경색상 */
  & > .vs-row:first-child,
  & > .vs-row > div:first-child {
    background: #F9F9F9;
    color: #3C3C3C;
    font-weight: 500;
  }

  /* 패딩 */
  & > .vs-row > .vs-col > div,
  & > .vs-row > div:first-child {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i { width:20px; height: 20px; border:2px solid #cdcdcd; position: relative; margin-right: 6px; }
  & .feather-icon { transform: translateY(-4px); }
}

.print-radio {
  & > i { border-radius: 20px; }
}

.etc-input {
  width: 108px;
}
</style>
